"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FictiveWebShop = void 0;
var FictiveWebShop;
(function (FictiveWebShop) {
    FictiveWebShop["BEVER_NL"] = "143";
    FictiveWebShop["ASADVENTURE_COM"] = "95";
    FictiveWebShop["ASADVENTURE_NL"] = "207";
    FictiveWebShop["ASADVENTURE_FR"] = "189";
    FictiveWebShop["ASADVENTURE_LU"] = "190";
    FictiveWebShop["COTSWOLDOUTDOOR_COM"] = "62";
    FictiveWebShop["SNOWANDROCK_COM"] = "210";
    FictiveWebShop["CYCLESURGERY_COM"] = "211";
    FictiveWebShop["RUNNERSNEED_COM"] = "212";
    FictiveWebShop["ASADVENTURE_CO_UK"] = "199";
    FictiveWebShop["COTSWOLDOUTDOOR_IE"] = "139";
    FictiveWebShop["COTSWOLDOUTDOOR_US"] = "142";
    FictiveWebShop["COTSWOLDOUTDOOR_COM_AU"] = "145";
    FictiveWebShop["JUTTU_BE"] = "224";
    FictiveWebShop["YAYA_BE"] = "229";
})(FictiveWebShop || (exports.FictiveWebShop = FictiveWebShop = {}));
//# sourceMappingURL=GeneralEnums.js.map